import * as React from 'react';
import { Fragment } from 'react';
import { makeStyles } from 'tss-react/mui';
import { required, minLength, maxLength, minValue, maxValue, number, regex, email, choices, Form, useResourceContext, useNotify, FunctionField, SelectField, TabbedForm, AutocompleteInput, HttpError, useRefresh, ArrayInput, SimpleFormIterator, FormDataConsumer, useSimpleFormIteratorItem, useUpdate, useSaveContext, useRecordContext, useList, ListContextProvider, NumberField, Loading, useEditContext } from 'react-admin';
import {
  useListContext,
  useRedirect,
  List,
  Datagrid,
  Filter,
  Edit,
  Create,

  Toolbar,
  TopToolbar,
  DeleteWithConfirmButton,
  BulkDeleteWithConfirmButton,
  Show,
  SimpleShowLayout,

  ReferenceField,
  TextField,
  ImageField,
  BooleanField,

  SimpleForm,
  ReferenceInput,
  SelectInput,
  TextInput,
  NumberInput,
  BooleanInput,
  NullableBooleanInput,

  Button,
  EditButton,
  ShowButton,
  SaveButton,
} from 'react-admin';
import { useForm, useFormContext, useFormState } from 'react-hook-form';
import { Button as MButton, TextField as MTextField, Box, useMediaQuery, Stack, Chip, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Backdrop, CircularProgress, Typography, IconButton, Paper, Switch, FormControlLabel } from '@mui/material';
import { AllImageField, FirstImageField, PreviewImage, UpLoadFile } from './custom/UpLoadFile';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import SearchIcon from '@mui/icons-material/Search';
import ClearAllIcon from '@mui/icons-material/ClearAll';
import { apiUrl, BaseUrl } from '../../global';
import { httpClient } from '../dataProvider';
import { useMutation, useQuery } from 'react-query';
import qs from 'qs';
import { MRichTextInput } from './custom/MRichTextInput';
import DeleteIcon from '@mui/icons-material/Delete';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
//import ResetOrderNum from './Product_ResetOrderNum';
import JsonView from '@uiw/react-json-view';
import copy from 'copy-to-clipboard';

{/* 
  import { ProductList, ProductCreate, ProductEdit, ProductShow } from './components/Product';

  <Resource name="CMSProduct" list={ProductList} create={ProductCreate} edit={ProductEdit} show={ProductShow} />
  <Resource name="CMSProduct" list={ListGuesser} create={EditGuesser} edit={EditGuesser} edit={ShowGuesser} /> 
*/}

const useStyles = makeStyles()((theme) => {
  return {
    imageField: {
      '& img.RaImageField-image': { width: 60 }
    },
  };
});


const useTxtData = {
  page: {
    tableName: 'Product',
  },
  table: {
    id: 'id',
    Cate2: 'Cate2',
    Supplier_id2: 'Supplier_id2',
    Supplier_id: 'Supplier_id',
    ProductCompany_id: 'ProductCompany_id',
    ProductCountry_id: 'ProductCountry_id',
    Cate1: 'Cate1',
    P_CommonTitle: 'P_CommonTitle',
    P_CommonTitleEN: 'P_CommonTitleEN',
    P_BrandName: 'P_BrandName',
    P_BrandNameEN: 'P_BrandNameEN',
    P_OtherNames: 'P_OtherNames',
    P_Application: 'P_Application',
    P_Images: 'P_Images',
    P_GoodsFreightNum: 'P_GoodsFreightNum',
    P_key: 'P_key',
    P_LimitNum: 'P_LimitNum',
    P_LimitNumMin: 'P_LimitNumMin',
    P_ProContent: 'P_ProContent',
    P_ProNum: 'P_ProNum',
    P_Price_sc: 'P_Price_sc',
    P_PriceGH: 'P_PriceGH',
    P_Price: 'P_Price',
    P_CostPrice: 'P_CostPrice',
    P_CostPriceM: 'P_CostPriceM',
    P_DLPrice: 'P_DLPrice',
    P_DLPriceM: 'P_DLPriceM',
    P_Hits: 'P_Hits',
    P_Dosage: 'P_Dosage',
    P_SaleNum: 'P_SaleNum',
    P_CustomUnit: 'P_CustomUnit',
    P_CustomUnitEN: 'P_CustomUnitEN',
    P_SmallUnit: 'P_SmallUnit',
    P_SmallUnitEN: 'P_SmallUnitEN',
    P_TYSX: 'P_TYSX',
    P_TYPY: 'P_TYPY',
    P_PPSX: 'P_PPSX',
    P_PPPY: 'P_PPPY',
    P_QTSX: 'P_QTSX',
    P_QTPY: 'P_QTPY',
    P_DirectSupply: 'P_DirectSupply',
    P_TransportType: 'P_TransportType',
    P_Transport: 'P_Transport',
    P_Storage: 'P_Storage',
    P_DetailRemarks: 'P_DetailRemarks',
    P_DetailRemarksEN: 'P_DetailRemarksEN',
    P_ProductDate: 'P_ProductDate',
    P_Information: 'P_Information',
    P_Japanese: 'P_Japanese',
    P_PolularScience: 'P_PolularScience',
    P_Reference: 'P_Reference',
    P_Reservation: 'P_Reservation',
    P_IsShelves: 'P_IsShelves',
    P_IsRecommend: 'P_IsRecommend',
    P_IsBrandDrug: 'P_IsBrandDrug',
    P_Iseview: 'P_Iseview',
    Recommended: 'Recommended',
    RecommendOrder: 'RecommendOrder',
    OrderNum: 'OrderNum',
    P_IsHFGM: 'P_IsHFGM',
    IsSure: 'IsSure',
    MinPriceBS: 'MinPriceBS',
    P_Address: 'P_Address',
    ISHuiZhen: 'ISHuiZhen',
    UpTime: 'UpTime',
    A: 'A',
    B: 'B',
    C: 'C',
    D: 'D',
    E: 'E',
    P_Manual: 'P_Manual',
    ZiXingQingGuan: 'ZiXingQingGuan',
    IsMainId: 'IsMainId',
  }
};

//分页列表页面
export const ProductList = () => {
  const notify = useNotify();
  const refresh = useRefresh();
  const redirect = useRedirect();//奇怪问题：这句必须保留，去掉后下面Filters里的setFilters({}, displayedFilters);会失效
  const isSmall = useMediaQuery((theme: any) => theme.breakpoints.down('sm'));
  // 筛选器模块
  // const Filters = () => {
  //   return (
  //     <Filter>
  //       <TextInput label="ID" source="id" alwaysOn />
  //     </Filter>
  //   );
  // };
  const MobileFilters = [
    <TextInput label="关键词" source="Key" alwaysOn resettable />
  ];
  const Filters = (props: any) => {
    const { displayedFilters, filterValues, setFilters, hideFilter, refetch } = useListContext();
    if (isSmall) return null;
    if (props.context === "button") return null;
    const onSubmit = (values: any) => { if (Object.keys(values).length > 0) { setFilters(values, displayedFilters); } else { setFilters({}, displayedFilters); } };
    const resetFilter = () => { setFilters({}, displayedFilters); };
    return (
      <div>
        <Form onSubmit={onSubmit} defaultValues={filterValues}>
          <Stack direction={'row'} alignItems={'center'} sx={{ gap: 1.5 }}>
            <TextInput label="关键词" source="Key" alwaysOn resettable helperText={false} />
            <ReferenceInput source={'Supplier_id'} reference="Admin/CMSSupplier">
              <AutocompleteInput label='供货商' sx={{ width: 200 }} optionText={({ S_Name, S_CountryId }: any) => `${S_CountryId}-${S_Name}`} helperText={false} />
            </ReferenceInput>
            <ReferenceInput source="ProductCompany_id" reference="Admin/CMSProductCompany" alwaysOn resettable helperText={false}>
              <AutocompleteInput sx={{ minWidth: 200 }} label='厂家' optionText={({ C_NameEN, C_Name }: any) => `${C_NameEN}(${C_Name})`} helperText={false} />
            </ReferenceInput>
            <ReferenceInput source="ProductCountry_id" reference="Admin/CMSProductCountry" alwaysOn resettable helperText={false}>
              <AutocompleteInput sx={{ minWidth: 200 }} label='产地' optionText={({ C_NameEN, C_Name }: any) => `${C_NameEN}(${C_Name})`} helperText={false} />
            </ReferenceInput>
            <SelectInput label='状态' source="Status" alwaysOn helperText={false} choices={[
              { id: 'sj', name: '上架' }
            ]} />
            <MButton variant="contained" color="primary" type="submit" startIcon={<SearchIcon />}>搜索</MButton>
            <MButton variant="outlined" onClick={resetFilter} startIcon={<ClearAllIcon />}>重置</MButton>
          </Stack>
        </Form>
      </div>
    );
  };

  //批量操作模块
  const PostBulkActionButtons = () => {
    return (
      <Fragment>
        {/* <ResetOrderNum label="重置排序"  /> */}
        {/* <BulkDeleteWithConfirmButton confirmTitle="删除确认" confirmContent="确认要删除所选记录吗？" mutationMode='undoable' /> */}
      </Fragment>
    );
  };
  //行右侧功能按钮
  const RowAction = () => {
    const { id } = useRecordContext();
    return (
      <div style={{ textAlign: 'right' }}>
        <EditButton /><br />
        {/* <ShowButton /><br /> */}
        {/* <DeleteWithConfirmButton confirmTitle="删除确认" confirmContent="确认要删除该记录吗？" /> */}
        <CopyView id={id} />
      </div>
    );
  }

  const ExpandSupplierView = ({ id }: any) => {
    const { displayedFilters, filterValues } = useListContext();
    const Status = filterValues?.Status ?? null;
    const Supplier_id = filterValues?.Supplier_id ?? null;
    const { data: __item_products, isLoading, isError, error, isSuccess, refetch } = useQuery(['GetSuppliers', id, Status, Supplier_id], () =>
      httpClient(`${apiUrl}/Admin/CMSProduct/GetSuppliers`, {
        method: 'POST',
        contentType: 'application/x-www-form-urlencoded',
        body: qs.stringify({ id, Status, Supplier_id })
      }).then(({ json }) => {
        if (json.Code == 1) {
          return json.Result || 'null';
        }
      }), {}
    )
    if (isLoading) return <div>loading</div>
    return <ExpandSupplierView_sub data={__item_products} />
  }
  const ExpandSupplierView_sub = ({ data }: any) => {
    var list = useList({ data: data })
    const [statusEditRecord, setStatusEditRecord] = React.useState<any>(null);
    return (
      <Stack sx={{ px: 10, py: 2, '& table': { backgroundColor: '#ededed' }, '& .RaDatagrid-headerCell ': { backgroundColor: '#e2e2e2' } }}>
        <ListContextProvider value={list}>
          <Datagrid bulkActionButtons={false}>
            <FunctionField label={'ID/主'} render={({ id, IsMainId }: any) =>
              <>
                <a href={`https://www2.xirou.com/detail/${id}`} target='_blank'><TextField source="id" sortable={false} /></a>
                {IsMainId && <BooleanField source="IsMainId" sortable={false} />}
              </>
            } />
            <ReferenceField label={'供货商'} source={'Supplier_id'} reference="Admin/CMSSupplier" link={false} sortable={false}>
              <FunctionField render={({ S_Name, S_CountryId }: any) => <Stack sx={{ minWidth: 100 }}>{`${S_CountryId}-${S_Name}`}</Stack>} />
            </ReferenceField>
            <FunctionField label={'细柔价'} render={({ id, P_Price, P_DLPrice }: any) =>
              <Stack direction={'row'} alignItems={'baseline'} spacing={0.25}>
                <a href={`https://www.xirou.com/product/productdetail.htm?Pid=${id}`} target='_blank'><Stack sx={{}}>{`¥${(P_Price ?? 0).toLocaleString('en-US')}`}</Stack></a>
                {(P_DLPrice ?? 0) > 0 && <Stack sx={{ fontSize: 12, color: '#888' }}>({`${parseFloat(((P_Price ?? 0) / (P_DLPrice ?? 0)).toFixed(1))}`}倍)</Stack>}
              </Stack>
            } />
            <FunctionField label={'服务商'} render={({ P_DLPrice, P_DLPriceM }: any) => <span>{`¥${(P_DLPrice ?? 0).toLocaleString('en-US')}($${(P_DLPriceM ?? 0).toLocaleString('en-US')})`}</span>} />
            <FunctionField label={'供货价'} render={({ P_CostPrice, P_CostPriceM }: any) => <span>{`¥${(P_CostPrice ?? 0).toLocaleString('en-US')}($${(P_CostPriceM ?? 0).toLocaleString('en-US')})`}</span>} />
            <FunctionField label={'上架|预定|恢购|会诊'} render={({ id, P_IsShelves, P_Reservation, P_IsHFGM, ISHuiZhen }: any) =>
              <Box sx={{ cursor: 'pointer', minWidth: 150 }} onClick={() => setStatusEditRecord({ id, P_IsShelves, P_Reservation, P_IsHFGM, ISHuiZhen })}>
                <Stack direction={'row'} spacing={1.6}>
                  <BooleanField source="P_IsShelves" sortable={false} sx={{ opacity: P_IsShelves ? 1 : 0.3, pointerEvents: 'none' }} />
                  {P_IsShelves == true && <>
                    <BooleanField source="P_Reservation" sortable={false} sx={{ opacity: P_Reservation ? 1 : 0.3, pointerEvents: 'none' }} />
                    <BooleanField source="P_IsHFGM" sortable={false} sx={{ opacity: P_IsHFGM ? 1 : 0.3, pointerEvents: 'none' }} />
                    <BooleanField source="ISHuiZhen" sortable={false} sx={{ opacity: ISHuiZhen ? 1 : 0.3, pointerEvents: 'none' }} />
                  </>
                  }
                </Stack>
              </Box>
            } />
            <StatusEditDialog open={!!statusEditRecord} record={statusEditRecord} onClose={() => setStatusEditRecord(null)} />
            <FunctionField label={'限购'} render={({ P_LimitNumMin, P_LimitNum }: any) => <Stack sx={{ minWidth: 50 }}>{`${P_LimitNumMin}-${P_LimitNum}`}</Stack>} />
            <TextField label={'备注'} source="P_Address" maxWidth={400} sx={{ wordBreak: 'break-word', display: 'inline-block' }} sortable={false} />
            <FunctionField label={''} render={({ id }: any) =>
              <ShowLogs id={id} />
            } />
          </Datagrid>
        </ListContextProvider>
      </Stack>
    )
  }

  const { classes } = useStyles();
  return (
    <List
      title={useTxtData.page.tableName + '列表'}
      sort={{ field: 'id', order: 'DESC' }}
      filters={<Filters />}
      exporter={false}
      sx={{ "& .MuiToolbar-root .MuiToolbar-root": { height: 0, minHeight: 0 } }}
    >
      <Datagrid
        // bulkActionButtons={<PostBulkActionButtons />}
        bulkActionButtons={false}
        expand={ExpandSupplierView}
      >
        {/* <FunctionField label='图片' render={({ P_Images }: any) => {
          // var imgSrc = P_Images.split(',')[0];
          // return <img src={`${BaseUrl}${imgSrc}`} style={{ width: 100, height: 100 }} />
          return 
        }} /> */}
        <FunctionField label='ID/图片' render={({ id }: any) => <>
          <a href={`https://www2.xirou.com/detail/${id}`} target='_blank'><TextField label={useTxtData.table.id} source="id" sortable={false} /></a>
          <FirstImageField sx={{ '& img': { width: 60 } }} label='图片' source='P_Images' subSource='src' />
        </>} />

        <FunctionField label='产品名称' render={({ P_BrandNameEN, P_BrandName, P_CommonTitleEN, P_CommonTitle, P_ProContent, P_ProNum, P_SmallUnitEN }: any) =>
          <>
            <Stack direction={'row'} spacing={1} alignItems={'center'}>
              <Stack sx={{ color: '#AAA' }}>品牌名(外)</Stack>
              <TextField source="P_BrandNameEN" />
              <Stack onClick={() => {
                copy(`${P_BrandNameEN}\t${P_BrandName}\t${P_CommonTitleEN}\t${P_CommonTitle}\t${P_ProContent}\t${P_ProNum}${P_SmallUnitEN}`, { format: 'text/plain' });
                notify('复制成功', { type: 'success' });
              }}><ContentCopyIcon sx={{ fontSize: 14 }} /></Stack>
            </Stack>
            <Stack direction={'row'} spacing={1}><Stack sx={{ color: '#AAA' }}>品牌名(中)</Stack><TextField source="P_BrandName" /></Stack>
            <Stack direction={'row'} spacing={1}><Stack sx={{ color: '#AAA' }}>通用名(外)</Stack><TextField source="P_CommonTitleEN" /></Stack>
            <Stack direction={'row'} spacing={1}><Stack sx={{ color: '#AAA' }}>通用名(中)</Stack><TextField source="P_CommonTitle" /></Stack>
            {/* <Stack direction={'row'} spacing={1}><TextField source="P_OtherNames" /></Stack> */}
          </>
        } />


        <FunctionField label='产品信息' render={() =>
          <>
            <Stack direction={'row'} spacing={2}>
              <Stack direction={'row'} spacing={1}>
                {/* <TextField source="P_IsBrandDrug" /> */}
                <SelectField source="P_IsBrandDrug" choices={[
                  { id: 1, name: '原研产品' },
                  { id: 2, name: '仿制产品' },
                  { id: 3, name: '未确定' },
                  { id: 4, name: '通用产品' },
                ]} />
              </Stack>
              <Stack direction={'row'} spacing={1}><Stack sx={{ color: '#AAA' }}>厂家</Stack>
                {/* <TextField source="ProductCompany_id" /> */}
                <ReferenceField source="ProductCompany_id" reference="Admin/CMSProductCompany" link={false} >
                  <FunctionField render={({ C_Name, C_NameEN }: any) => <>
                    {/* {C_Name.length > 0 ? C_Name : C_NameEN} */}
                    {`${C_NameEN}|${C_Name}`}
                  </>} />
                </ReferenceField>
              </Stack>
              <Stack direction={'row'} spacing={1}><Stack sx={{ color: '#AAA' }}>产地</Stack>
                {/* <TextField source="ProductCountry_id" /> */}
                <ReferenceField source="ProductCountry_id" reference="Admin/CMSProductCountry" link={false} >
                  <FunctionField render={({ C_Name, C_NameEN }: any) => <>
                    {/* {C_Name.length > 0 ? C_Name : C_NameEN} */}
                    {`${C_NameEN}|${C_Name}`}
                  </>} />
                </ReferenceField>
              </Stack>
            </Stack>
            <Stack direction={'row'} spacing={2}>
              <Stack direction={'row'} spacing={1}><Stack sx={{ color: '#AAA' }}>含量</Stack><TextField source="P_ProContent" /></Stack>
              <Stack direction={'row'} spacing={1}><Stack sx={{ color: '#AAA' }}>包装</Stack>
                <Stack direction={'row'} spacing={0}><TextField source="P_ProNum" /><TextField source="P_SmallUnit" />/<TextField source="P_CustomUnit" /></Stack>
              </Stack>
              <Stack direction={'row'} spacing={1}><Stack sx={{ color: '#AAA' }}>剂型|给药</Stack><TextField source="P_Dosage" /></Stack>
            </Stack>
            <FunctionField render={({ P_OtherNames }: any) =>
              <>{P_OtherNames && <Stack direction={'row'} spacing={1}><Stack sx={{ color: '#AAA' }}>其它名</Stack><TextField source="P_OtherNames" /></Stack>}</>
            } />
            <FunctionField render={({ P_Application }: any) =>
              <Stack direction={'row'} spacing={1}><Stack sx={{ color: '#AAA' }}>药作用</Stack><TextField title={P_Application} sx={{ maxWidth: 350, 'white-space': 'nowrap', 'overflow': 'hidden', 'text-overflow': 'ellipsis' }} source="P_Application" /></Stack>
            } />
          </>
        } />

        <FunctionField label='所属分类' render={({ id, Cate1, Cate2 }: any) =>
          <>
            <SortView id={id} Cate1={Cate1} Cate2={Cate2} />
          </>
        } />

        <FunctionField label='运输存储' render={() =>
          <>
            {/* <Stack direction={'row'} spacing={1}><Stack sx={{ color: '#AAA' }}>直供产品</Stack><TextField source="P_DirectSupply" /></Stack> */}
            <Stack direction={'row'} spacing={1}><Stack sx={{ color: '#AAA' }}>运输方式</Stack>
              {/* <TextField source="P_TransportType" /> */}
              <SelectField source="P_TransportType" choices={[
                { id: 1, name: '常温运输' },
                { id: 2, name: '冷链运输' },
                { id: 3, name: '阴凉运输' },
                { id: 4, name: '低温运输' },
              ]} />
            </Stack>
            <FunctionField render={({ P_Transport, P_Storage }: any) =>
              <>
                {P_Transport && <Stack direction={'row'} spacing={1}><Stack sx={{ color: '#AAA' }}>运输温度</Stack><TextField source="P_Transport" /></Stack>}
                {P_Storage && <Stack direction={'row'} spacing={1}><Stack sx={{ color: '#AAA' }}>存储温度</Stack><TextField source="P_Storage" /></Stack>}
              </>
            } />
          </>
        } />
        {/* <FunctionField label='产品信息' render={({ id }: any) =>
          <TongJiView id={id} />
        } /> */}

        <FunctionField label={'更新/状态'} render={({ id, UpTime }: any) => <>
          <div dangerouslySetInnerHTML={{ __html: UpTime }}></div>
          <TongJiView id={id} />
        </>} />

        <RowAction />
      </Datagrid>
    </List>
  );
};

const SortView = ({ id, Cate2 }: any) => {
  const { data: __sortArr, isLoading, isError, error, isSuccess, refetch } = useQuery(['getSorts', Cate2], () =>
    httpClient(`${apiUrl}/Admin/CMSProduct/GetSorts`, {
      method: 'POST',
      contentType: 'application/x-www-form-urlencoded',
      body: qs.stringify({ CheckCate: true, Cate2 })
    }).then(({ json }) => {
      if (json.Code == 1) return json.Result || 'null';
    }), {}
  )
  if (isLoading) return <div>loading</div>
  return (
    <ChooseSortViewByList id={id} C_Cate2={Cate2} C__sortArr={__sortArr} />
  )
}

const TongJiView = ({ id }: any) => {
  const { displayedFilters, filterValues } = useListContext();
  const Status = filterValues?.Status ?? null;
  const Supplier_id = filterValues?.Supplier_id ?? null;
  const { data: __tongji, isLoading, isError, error, isSuccess, refetch } = useQuery(['getTongJi', id], () =>
    httpClient(`${apiUrl}/Admin/CMSProduct/GetTongJi`, {
      method: 'POST',
      contentType: 'application/x-www-form-urlencoded',
      body: qs.stringify({ id, Status, Supplier_id })
    }).then(({ json }) => {
      if (json.Code == 1) return json.Result || 'null';
    }), {}
  )
  if (isLoading) return <div>loading</div>
  const { _sjCount, _ydCount, _hfCount, _hzCount, _xjCount } = __tongji;
  return <Stack sx={{ minWidth: 80 }}>
    <Stack direction={'row'} spacing={1}>
      <Stack sx={{ color: _sjCount > 0 ? 'green' : 'default', fontWeight: _sjCount > 0 ? 'bold' : 'normal' }} direction={'row'} spacing={1}><Stack sx={{ color: _sjCount > 0 ? 'default' : '#AAA' }}>上架</Stack>({_sjCount})</Stack>
      <Stack direction={'row'} spacing={1}><Stack sx={{ color: '#AAA' }}>下架</Stack>({_xjCount})</Stack>
      <Stack direction={'row'} spacing={1}><Stack sx={{ color: '#AAA' }}>预定</Stack>({_ydCount})</Stack>
    </Stack>
    <Stack direction={'row'} spacing={1}>
      <Stack direction={'row'} spacing={1}><Stack sx={{ color: '#AAA' }}>恢复</Stack>({_hfCount})</Stack>
      <Stack direction={'row'} spacing={1}><Stack sx={{ color: '#AAA' }}>会诊</Stack>({_hzCount})</Stack>
    </Stack>
  </Stack>
}

const ShowLogs = ({ id }: any) => {
  const refresh = useRefresh();
  const [open, setOpen] = React.useState(false);
  const handleClickOpen = () => {
    setOpen(true);
    refetch();
  };
  const handleClose = () => {
    setOpen(false);
  };

  const { data, isLoading, isError, error, isSuccess, refetch } = useQuery(['getLogss', id], () =>
    httpClient(`${apiUrl}/Admin/CMSProduct/GetLogs`, {
      method: 'POST',
      contentType: 'application/x-www-form-urlencoded',
      body: qs.stringify({ id })
    }).then(({ json }) => {
      if (json.Code == 1) return json.Result || 'null';
    }), { enabled: false }
  )

  console.log('log data', data)

  return (
    <>
      <Button label="日志" onClick={() => handleClickOpen()} />
      <Dialog
        open={open}
        maxWidth='xl'
        scroll={'paper'}
        onClose={handleClose}
      >
        <DialogTitle>ID:{id}日志记录(*表示修改)</DialogTitle>
        <DialogContent>
          {isLoading && <div>loading</div>}
          {isSuccess && data.map(({ id, UpTime, Modifier, Operator, BeforeChange, AfterChange }: any, _ind: number) => {
            return (
              <Stack direction={'column'} sx={{ py: 1 }}>
                <Stack direction={'row'} spacing={2} alignItems={'center'}>
                  <span style={{ fontSize: 12 }}>{_ind + 1}#</span>
                  <span style={{ fontSize: 12 }}>记录时间:{UpTime}</span>
                  <span style={{ fontSize: 12 }}>修改人:{Modifier}</span>
                  <span style={{ fontSize: 12 }}>操作人:{Operator}</span>
                </Stack>
                <Stack direction={'row'}>
                  <Stack sx={{ flex: 1 }}>
                    <JsonView displayDataTypes={false} value={JSON.parse(BeforeChange)} />
                  </Stack>
                  <Stack sx={{ flex: 1 }}>
                    <JsonView displayDataTypes={false} value={JSON.parse(AfterChange)} />
                  </Stack>
                </Stack>
              </Stack>
            )
          })}
        </DialogContent>
        <DialogActions>
          <MButton color='warning' onClick={handleClose}>关闭</MButton>
        </DialogActions>
      </Dialog>
    </>
  )
}

const CopyView = ({ id }: any) => {
  const refresh = useRefresh();
  const [open, setOpen] = React.useState(false);
  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };
  const { mutate: _copyProduct, isLoading } = useMutation((data: any) =>
    httpClient(`${apiUrl}/Admin/CMSProduct/CopyProduct`, {
      method: 'POST', contentType: 'application/x-www-form-urlencoded',
      body: qs.stringify(data)
    }).then(({ json }) => {
      if (json.Code == 1) {
        alert(json.Message);
        setOpen(false);
      } else { throw new HttpError(`${json.Message}`, 500); }
    }), {
    onSuccess: () => { refresh() },
    onError: (err) => { alert(`${err}`) }
  })
  const copyPro = (data: any) => {
    if (window.confirm('请确保复制后的产品【品牌名、厂家、产地、含量、包装】至少有一项和原产品不一致！复制后产品默认为下架状态需自行在调整')) {
      _copyProduct(data);
    }
  }
  const submit = (data: any) => {
    console.log('data', data)
    const { id, P_BrandNameEN, P_ProContent, P_ProNum, ProductCompany_id, ProductCountry_id } = data;
    console.log('Data', { id, P_BrandNameEN, P_ProContent, P_ProNum, ProductCompany_id, ProductCountry_id })
    copyPro({ id, P_BrandNameEN, P_ProContent, P_ProNum, ProductCompany_id, ProductCountry_id });
    return false;
  }
  return (
    <>
      <Button label="复制" onClick={() => handleClickOpen()}>
        <ContentCopyIcon />
      </Button>
      <Dialog open={open}>
        <DialogTitle>快速复制产品</DialogTitle>
        <DialogContent>
          <DialogContentText>
            请确保复制后的产品【品牌名、厂家、产地、含量、包装】至少有一项和原产品不一致！
            复制后产品默认为下架状态需自行在调整
          </DialogContentText>
          {/* <Stack direction={'row'}>
            <MTextField label="P_BrandNameEN" defaultValue={'1'} />
            <MTextField label="P_ProContent" />
            <MTextField label="P_ProNum" />
          </Stack>
          <Stack direction={'row'}>
          </Stack> */}
          <Form onSubmit={submit}>
            <DialogContent>
              <Stack direction={'row'} sx={{ gap: 1 }}>
                <TextInput label='品牌外文名' source="P_BrandNameEN" validate={[required()]} />
                <TextInput label='含量' source="P_ProContent" validate={[required()]} />
                <TextInput label='包装' source="P_ProNum" validate={[required()]} />
              </Stack>
              <Stack sx={{}}>
                <ReferenceInput source="ProductCompany_id" reference="Admin/CMSProductCompany" >
                  <AutocompleteInput label='厂家' optionText={({ C_NameEN, C_Name }: any) => `${C_NameEN}(${C_Name})`} validate={[required()]} />
                </ReferenceInput>
                <ReferenceInput source="ProductCountry_id" reference="Admin/CMSProductCountry" >
                  <AutocompleteInput label='产地' optionText={({ C_NameEN, C_Name }: any) => `${C_NameEN}(${C_Name})`} validate={[required()]} />
                </ReferenceInput>
              </Stack>
            </DialogContent>
            <DialogActions>
              <MButton color='warning' onClick={handleClose}>取消</MButton>
              <SaveButton label={isLoading ? '复制中...' : '确定复制'} disabled={isLoading} />
            </DialogActions>
          </Form>
        </DialogContent>
      </Dialog>
    </>
  )
}

const StatusEditDialog = ({ open, record, onClose }: any) => {
  const notify = useNotify();
  const refresh = useRefresh();
  const [form, setForm] = React.useState({ ...record });

  React.useEffect(() => {
    setForm({ ...record });
  }, [record]);

  const { mutate: _saveStatus, isLoading } = useMutation((data: any) =>
    httpClient(`${apiUrl}/Admin/CMSProduct/SetStatus`, {
      method: 'POST', contentType: 'application/x-www-form-urlencoded',
      body: qs.stringify(data)
    }).then(({ json }) => {
      if (json.Code == 1) {
        notify('状态已更新', { type: 'success' });
        onClose();
        refresh();
      } else { throw new HttpError(`${json.Message}`, 500); }
    }), {
    onError: (err) => { notify(`更新失败: ${err}`, { type: 'error' }); }
  })

  const handleToggle = (field: string) => {
    setForm((prev: any) => ({ ...prev, [field]: !prev[field] }));
  };

  const handleSave = () => {
    _saveStatus({
      id: record.id,
      P_IsShelves: form.P_IsShelves,
      P_Reservation: form.P_Reservation,
      P_IsHFGM: form.P_IsHFGM,
      ISHuiZhen: form.ISHuiZhen,
    });
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth='xs' fullWidth>
      <DialogTitle>设置产品状态</DialogTitle>
      <DialogContent>
        <Stack direction={'row'} spacing={1} sx={{ mt: 1, flexWrap: 'wrap' }}>
          <FormControlLabel
            control={<Switch checked={form.P_IsShelves} onChange={() => handleToggle('P_IsShelves')} />}
            label="上架"
          />
          <FormControlLabel
            control={<Switch checked={form.P_Reservation} onChange={() => handleToggle('P_Reservation')} />}
            label="预定"
          />
          <FormControlLabel
            control={<Switch checked={form.P_IsHFGM} onChange={() => handleToggle('P_IsHFGM')} />}
            label="恢购"
          />
          <FormControlLabel
            control={<Switch checked={form.ISHuiZhen} onChange={() => handleToggle('ISHuiZhen')} />}
            label="会诊"
          />
          {/* {form.P_IsShelves && [form.P_Reservation, form.P_IsHFGM, form.ISHuiZhen].filter(Boolean).length > 1 &&
            <Typography color="error" variant="caption">预定、恢购、会诊三选一，不能同时开启多个</Typography>
          } */}
        </Stack>
      </DialogContent>
      <DialogActions>
        <MButton color='warning' onClick={onClose}>取消</MButton>
        <MButton color='primary' variant='contained' onClick={handleSave} disabled={isLoading}>
          {isLoading ? '保存中...' : '保存'}
        </MButton>
      </DialogActions>
    </Dialog>
  );
};

////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////

//SHOW页面
export const ProductShow = () => {
  const ShowActions = () => {
    const resource = useResourceContext();
    const redirect = useRedirect();
    return (
      <TopToolbar>
        <Button label="返回列表" onClick={() => redirect(`/${resource}`)} variant="text">
          <ArrowBackIcon />
        </Button>
        <EditButton />
      </TopToolbar>
    );
  };

  const { classes } = useStyles();
  return (
    <Show title={'查看' + useTxtData.page.tableName} actions={<ShowActions />}>
      <SimpleShowLayout>
        {/* <TextField source="id" /> */}
        {/* <TextField label="名称" source="Name" /> */}
        {/* <TextField label="排序" source="OrderNum" />  */}
        <TextField label={useTxtData.table.id} source="id" />
        <TextField label={useTxtData.table.Cate2} source="Cate2" />
        <TextField label={useTxtData.table.Supplier_id2} source="Supplier_id2" />
        <TextField label={useTxtData.table.Supplier_id} source="Supplier_id" />
        <TextField label={useTxtData.table.ProductCompany_id} source="ProductCompany_id" />
        <TextField label={useTxtData.table.ProductCountry_id} source="ProductCountry_id" />
        <TextField label={useTxtData.table.Cate1} source="Cate1" />
        <TextField label={useTxtData.table.P_CommonTitle} source="P_CommonTitle" />
        <TextField label={useTxtData.table.P_CommonTitleEN} source="P_CommonTitleEN" />
        <TextField label={useTxtData.table.P_BrandName} source="P_BrandName" />
        <TextField label={useTxtData.table.P_BrandNameEN} source="P_BrandNameEN" />
        <TextField label={useTxtData.table.P_OtherNames} source="P_OtherNames" />
        <TextField label={useTxtData.table.P_Application} source="P_Application" />
        <TextField label={useTxtData.table.P_Images} source="P_Images" />
        <TextField label={useTxtData.table.P_GoodsFreightNum} source="P_GoodsFreightNum" />
        <TextField label={useTxtData.table.P_key} source="P_key" />
        <TextField label={useTxtData.table.P_LimitNum} source="P_LimitNum" />
        <TextField label={useTxtData.table.P_LimitNumMin} source="P_LimitNumMin" />
        <TextField label={useTxtData.table.P_ProContent} source="P_ProContent" />
        <TextField label={useTxtData.table.P_ProNum} source="P_ProNum" />
        <TextField label={useTxtData.table.P_Price_sc} source="P_Price_sc" />
        <TextField label={useTxtData.table.P_PriceGH} source="P_PriceGH" />
        <TextField label={useTxtData.table.P_Price} source="P_Price" />
        <TextField label={useTxtData.table.P_CostPrice} source="P_CostPrice" />
        <TextField label={useTxtData.table.P_CostPriceM} source="P_CostPriceM" />
        <TextField label={useTxtData.table.P_DLPrice} source="P_DLPrice" />
        <TextField label={useTxtData.table.P_DLPriceM} source="P_DLPriceM" />
        <TextField label={useTxtData.table.P_Hits} source="P_Hits" />
        <TextField label={useTxtData.table.P_Dosage} source="P_Dosage" />
        <TextField label={useTxtData.table.P_SaleNum} source="P_SaleNum" />
        <TextField label={useTxtData.table.P_CustomUnit} source="P_CustomUnit" />
        <TextField label={useTxtData.table.P_CustomUnitEN} source="P_CustomUnitEN" />
        <TextField label={useTxtData.table.P_SmallUnit} source="P_SmallUnit" />
        <TextField label={useTxtData.table.P_SmallUnitEN} source="P_SmallUnitEN" />
        <TextField label={useTxtData.table.P_TYSX} source="P_TYSX" />
        <TextField label={useTxtData.table.P_TYPY} source="P_TYPY" />
        <TextField label={useTxtData.table.P_PPSX} source="P_PPSX" />
        <TextField label={useTxtData.table.P_PPPY} source="P_PPPY" />
        <TextField label={useTxtData.table.P_QTSX} source="P_QTSX" />
        <TextField label={useTxtData.table.P_QTPY} source="P_QTPY" />
        <TextField label={useTxtData.table.P_DirectSupply} source="P_DirectSupply" />
        <TextField label={useTxtData.table.P_TransportType} source="P_TransportType" />
        <TextField label={useTxtData.table.P_Transport} source="P_Transport" />
        <TextField label={useTxtData.table.P_Storage} source="P_Storage" />
        <TextField label={useTxtData.table.P_DetailRemarks} source="P_DetailRemarks" />
        <TextField label={useTxtData.table.P_DetailRemarksEN} source="P_DetailRemarksEN" />
        <TextField label={useTxtData.table.P_ProductDate} source="P_ProductDate" />
        <TextField label={useTxtData.table.P_Information} source="P_Information" />
        <TextField label={useTxtData.table.P_Japanese} source="P_Japanese" />
        <TextField label={useTxtData.table.P_PolularScience} source="P_PolularScience" />
        <TextField label={useTxtData.table.P_Reference} source="P_Reference" />
        <TextField label={useTxtData.table.P_Reservation} source="P_Reservation" />
        <TextField label={useTxtData.table.P_IsShelves} source="P_IsShelves" />
        <TextField label={useTxtData.table.P_IsRecommend} source="P_IsRecommend" />
        <TextField label={useTxtData.table.P_IsBrandDrug} source="P_IsBrandDrug" />
        <TextField label={useTxtData.table.P_Iseview} source="P_Iseview" />
        <TextField label={useTxtData.table.Recommended} source="Recommended" />
        <TextField label={useTxtData.table.RecommendOrder} source="RecommendOrder" />
        <TextField label={useTxtData.table.OrderNum} source="OrderNum" />
        <TextField label={useTxtData.table.P_IsHFGM} source="P_IsHFGM" />
        <TextField label={useTxtData.table.IsSure} source="IsSure" />
        <TextField label={useTxtData.table.MinPriceBS} source="MinPriceBS" />
        <TextField label={useTxtData.table.P_Address} source="P_Address" />
        <TextField label={useTxtData.table.ISHuiZhen} source="ISHuiZhen" />
        <TextField label={useTxtData.table.UpTime} source="UpTime" />
        <TextField label={useTxtData.table.A} source="A" />
        <TextField label={useTxtData.table.B} source="B" />
        <TextField label={useTxtData.table.C} source="C" />
        <TextField label={useTxtData.table.D} source="D" />
        <TextField label={useTxtData.table.E} source="E" />
        <TextField label={useTxtData.table.P_Manual} source="P_Manual" />
        <TextField label={useTxtData.table.ZiXingQingGuan} source="ZiXingQingGuan" />
        <TextField label={useTxtData.table.IsMainId} source="IsMainId" />
      </SimpleShowLayout>
    </Show>
  );
}

////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////

//编辑页面
export const ProductEdit = () => {
  const resource = useResourceContext();
  const redirect = useRedirect();
  const [loading, setLoading] = React.useState(true);

  const PostEditActions = () => {
    return (
      <TopToolbar >
        <Button label="返回列表" onClick={() => redirect(`/${resource}`)} variant="text">
          <ArrowBackIcon />
        </Button>
      </TopToolbar>
    );
  };
  const PostEditToolbar = () => {
    const saveContext = useSaveContext();
    const { isSubmitting } = useFormState();
    const saving = isSubmitting || (saveContext?.saving || false);
    return (
      <Toolbar>
        <SaveButton alwaysEnable />
        <Backdrop sx={{ color: '#fff', zIndex: (theme: any) => theme.zIndex.drawer + 1 }} open={saving}  >
          <Paper elevation={3} sx={{ p: 4 }}>
            <Stack alignItems={'center'}>
              <CircularProgress color="inherit" />
              <Typography variant="h6" gutterBottom>
                数据正在提交中，请不要关闭页面
              </Typography>
            </Stack>
          </Paper>
        </Backdrop>
      </Toolbar>
    );
  };
  const onSuccess = () => {
    setTimeout(() => setLoading(false), 300);
  }
  return (
    <Edit sx={{ position: 'relative' }} queryOptions={{ onSuccess }} redirect={`/${resource}`} title={'编辑' + useTxtData.page.tableName} actions={<PostEditActions />} mutationMode="pessimistic">
      <MyForm Edit={true} toolbar={<PostEditToolbar />} />
      {loading && <Stack sx={{ position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: '#00000020', zIndex: 1 }} justifyContent={'center'} alignItems={'center'}>
        Loading<CircularProgress color="inherit" />
      </Stack>}
    </Edit>
  );
};

////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////

//创建页面
export const ProductCreate = () => {
  const resource = useResourceContext();
  const redirect = useRedirect();
  const notify = useNotify();

  const PostCreateActions = () => {
    return (
      <TopToolbar>
        <Button label="返回列表" onClick={() => redirect(`/${resource}`)} variant="text" >
          <ArrowBackIcon />
        </Button>
      </TopToolbar>
    );
  };
  const PostCreateToolbar = () => {
    const { reset, resetField, handleSubmit, setValue, getValues, } = useFormContext();
    return (
      <Toolbar>
        <SaveButton alwaysEnable label="保存&列表" />
        <SaveButton alwaysEnable type='button' label="保存&继续" variant="text" mutationOptions={{
          onSuccess: () => {
            notify('创建成功', { type: 'success' });
            reset();
          }
        }} />
      </Toolbar>
    );
  };

  return (
    <Create redirect={`/${resource}`} title={'新增' + useTxtData.page.tableName} actions={<PostCreateActions />}>
      <MyForm Create={true} toolbar={<PostCreateToolbar />} />
    </Create>
  );
};

////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////
//Create和Edit公用表单
const MyForm = (props: any) => {
  let { Edit, Create } = props;
  return (
    <TabbedForm {...props}>
      <TabbedForm.Tab label="基本信息">
        <Stack sx={{ width: '100%' }} direction={'row'} spacing={3}>
          <Stack flex={4}>
            {Create &&
              <Stack flexDirection={'row'} justifyItems={'flex-start'}>
                <AutoImportData />
              </Stack>
            }
            <Stack direction={'row'} spacing={1}>
              <Stack flex={1}>
                <TextInput label='品牌外文' source="P_BrandNameEN" validate={[required()]} disabled={Edit} />
                <TextInput label='通用外文' source="P_CommonTitleEN" validate={[required()]} />
              </Stack>
              <Stack flex={1}>
                <TextInput label='品牌中文' source="P_BrandName" />
                <TextInput label='通用中文' source="P_CommonTitle" />
              </Stack>
              <Stack flex={1}>
                {/* <TextInput label='厂家' source="P_CommonTitleEN" /> */}
                <ReferenceInput source="ProductCompany_id" reference="Admin/CMSProductCompany" >
                  <AutocompleteInput label='厂家' optionText={({ C_NameEN, C_Name }: any) => `${C_NameEN}(${C_Name})`} validate={[required()]} disabled={Edit} />
                </ReferenceInput>
                {/* <TextInput label='产地' source="P_CommonTitle" /> */}
                <ReferenceInput source="ProductCountry_id" reference="Admin/CMSProductCountry" >
                  <AutocompleteInput label='产地' optionText={({ C_NameEN, C_Name }: any) => `${C_NameEN}(${C_Name})`} validate={[required()]} disabled={Edit} />
                </ReferenceInput>
              </Stack>
            </Stack>

            <Stack direction={'row'} spacing={1}>
              <Stack flex={1}>
                <TextInput label='其它名称' source="P_OtherNames" />
              </Stack>
              <Stack flex={2}>
                <TextInput fullWidth label='关键词' source="P_key" />
              </Stack>
            </Stack>

            <Stack direction={'row'} spacing={1}>
              <Stack flex={1}>
                <TextInput label='含量' source="P_ProContent" validate={[required()]} disabled={Edit} />
                <TextInput label='数量' source="P_ProNum" validate={[required()]} disabled={Edit} />
              </Stack>
              <Stack flex={1}>
                {/* <TextInput label='小单位' source="P_SmallUnitEN" /> */}
                <AutocompleteInput label='小单位' validate={[required()]} source="P_SmallUnitEN" choices={[
                  { id: 'mg', name: 'mg(毫克)' },
                  { id: 'ml', name: 'ml(毫升)' },
                  { id: 'g', name: 'g(克)' },
                  { id: 'tablet', name: 'tablet(片)' },
                  { id: 'tablets', name: 'tablets(片)' },
                  { id: 'grain', name: 'grain(粒)' },
                  { id: 'Branch', name: 'Branch(支)' },
                  { id: 'Bags', name: 'Bags(袋)' },
                  { id: 'Boxes', name: 'Boxes(盒)' },
                  { id: 'Bottles', name: 'Bottles(瓶)' },
                ]} />
                {/* 毫克(mg)毫升(ml)克(g)支(Branch)片(tablet)粒(grain)袋(Bags)盒(Boxes)瓶(Bottles) */}

                {/* <TextInput label='大单位' source="P_CustomUnitEN" /> */}
                <AutocompleteInput label='大单位' validate={[required()]} source="P_CustomUnitEN" choices={[
                  { id: 'Packs', name: 'Packs(包)' },
                  { id: 'Bags', name: 'Bags(袋)' },
                  { id: 'Bottles', name: 'Bottles(瓶)' },
                  { id: 'Boxes', name: 'Boxes(盒)' },
                  // { id: 'boxes', name: 'boxes(盒)' },
                  { id: 'Branch', name: 'Branch(支)' },
                ]} />
                {/* 包(Packs)袋(Bags)瓶(Bottles)c(Boxes)支(Branch) */}


              </Stack>
              <Stack flex={1}>
                <SelectInput label='产品属性' source="P_IsBrandDrug" validate={[required()]} choices={[
                  { id: 1, name: '原研产品' },
                  { id: 2, name: '仿制产品' },
                  { id: 3, name: '未确定' },
                  { id: 4, name: '通用产品' },
                ]} />
                <TextInput label='剂型|给药' source="P_Dosage" />
              </Stack>
            </Stack>

            <Stack direction={'row'} spacing={1}>
              <Stack flex={1}>
                <TextInput fullWidth label='作用' source="P_Application" />
              </Stack>
            </Stack>

            <Stack direction={'row'} spacing={1}>
              <Stack flex={1}>
                <SelectInput label='运输方式' source="P_TransportType" validate={[required()]} choices={[
                  { id: 1, name: '常温运输' },
                  { id: 2, name: '冷链运输' },
                  { id: 3, name: '阴凉运输' },
                  { id: 4, name: '低温运输' },
                ]} />
              </Stack>
              <Stack flex={1}>
                <TextInput label='运输温度' source="P_Transport" />
              </Stack>
              <Stack flex={1}>
                <TextInput label='储存温度' source="P_Storage" />
              </Stack>
            </Stack>

          </Stack>
          <Stack flex={2}>
            <ImagePaster />
            <UpLoadFile multiple label={'图片(可以直接复制图片,然后按 Ctrl+V(或Cmd+V)粘贴到页面上)'} source="P_Images" validate={[]} />
          </Stack>
        </Stack>
      </TabbedForm.Tab>
      <TabbedForm.Tab label="分类信息">
        {/*<Stack>
          <TextInput label='分类1' source="Cate1" />
          <TextInput label='分类2' source="Cate2" />
          <TextInput label='分类2' source="__sortArr" />
        </Stack>*/}
        <Stack>
          {Edit && <FunctionField render={({ Cate2 }: any) => <>{<ChooseSortView C_Cate2={Cate2} />}</>} />}
          {Create && <ChooseSortView C_Cate2={''} />}
        </Stack>
      </TabbedForm.Tab>
      <TabbedForm.Tab label="供应信息">
        <ArrayInput label={'供货信息'} source="__item_products">
          <SimpleFormIterator fullWidth getItemLabel={(index: any) => `#${index + 1}`} disableClear={true} disableRemove={true}>
            <FormDataConsumer>
              {({
                formData, // The whole form data
                scopedFormData, // The data for this item of the ArrayInput
                getSource, // A function to get the valid source inside an ArrayInput
                ...rest
              }: any) => {
                return <MultipleSupplierItem getSource={getSource} />
              }}
            </FormDataConsumer>
          </SimpleFormIterator>
        </ArrayInput>
      </TabbedForm.Tab>
      <TabbedForm.Tab label="中(外)文说明书">
        <Stack direction={'row'} sx={{ width: '100%', gap: 1 }}>
          <Stack>
            <UpLoadFile notImg={true} accept="application/pdf" label={'pdf文件'} source="P_DetailRemarks_Pdfs" validate={[]} />
            <MRichTextInput fullWidth sx={{ flex: 1 }} label={'中文说明'} source="P_DetailRemarks" />
          </Stack>
          <Stack>
            <UpLoadFile notImg={true} accept="application/pdf" label={'pdf文件'} source="P_DetailRemarksEN_Pdfs" validate={[]} />
            <MRichTextInput fullWidth sx={{ flex: 1, '& img': { width: '100%' } }} label={'外文说明'} source="P_DetailRemarksEN" />
          </Stack>
        </Stack>
      </TabbedForm.Tab>
      <TabbedForm.Tab label="市场资料&患者科普">
        <Stack direction={'row'} sx={{ width: '100%', gap: 1 }}>
          <MRichTextInput fullWidth sx={{ flex: 1 }} label={'市场资料'} source="P_ProductDate" />
          <MRichTextInput fullWidth sx={{ flex: 1 }} label={'患者科普'} source="P_PolularScience" />
        </Stack>
      </TabbedForm.Tab>
      <TabbedForm.Tab label="使用说明书">
        <MRichTextInput fullWidth label={'使用说明书'} source="P_Manual" />
      </TabbedForm.Tab>

    </TabbedForm>
  );
}

const AutoImportData = () => {
  const [open, setOpen] = React.useState(false);
  const [jsonInput, setJsonInput] = React.useState('');
  const [parsing, setParsing] = React.useState(false);
  const { setValue, getValues } = useFormContext();
  const notify = useNotify();

  const handleClickOpen = () => {
    setOpen(true);
    setJsonInput('');
  };
  const handleClose = () => {
    setOpen(false);
    setJsonInput('');
  };

  // 解析并填充数据
  const parseAndFillData = (jsonData: any) => {
    try {
      // 品牌外文名
      if (jsonData.brand_name_en) {
        setValue('P_BrandNameEN', jsonData.brand_name_en);
      }

      // 品牌中文/日文
      if (jsonData.brand_name_jp) {
        setValue('P_BrandName', jsonData.brand_name_jp);
      }

      // 通用外文名
      if (jsonData.generic_name_en) {
        setValue('P_CommonTitleEN', jsonData.generic_name_en);
      }

      // 通用中文名
      if (jsonData.generic_name_cn) {
        setValue('P_CommonTitle', jsonData.generic_name_cn);
      }

      // 作用/适应症
      if (jsonData.indication_cn) {
        setValue('P_Application', jsonData.indication_cn);
      }

      // // 剂型
      // if (jsonData.dosage_form_en || jsonData.dosage_form_cn) {
      //   const dosageForm = [jsonData.dosage_form_en, jsonData.dosage_form_cn]
      //     .filter(Boolean)
      //     .join('|');
      //   setValue('P_Dosage', dosageForm);
      // }

      // 含量
      if (jsonData.strength) {
        setValue('P_ProContent', jsonData.strength);
      }

      // 包装数量
      if (jsonData.package_unit) {
        setValue('P_ProNum', jsonData.package_unit);
      }

      // // 厂家
      // if (jsonData.manufacturer) {
      //   // 需要根据厂家名称查找对应的ID
      //   findAndSetManufacturer(jsonData.manufacturer);
      // }

      // // 产地
      // if (jsonData.manufacturer_country) {
      //   // 需要根据国家名称查找对应的ID
      //   findAndSetCountry(jsonData.manufacturer_country);
      // }

      // 价格信息（如果有供货信息数组）
      if (jsonData.price) {
        addSupplierInfoFromImport(jsonData);
      }

      notify('数据导入成功', { type: 'success' });
      return true;
    } catch (error) {
      console.error('解析数据失败:', error);
      notify('数据解析失败，请检查JSON格式', { type: 'error' });
      return false;
    }
  };

  // 根据厂家名称查找并设置厂家ID
  const findAndSetManufacturer = async (manufacturerName: string) => {
    // try {
    //   // 首先尝试从已有数据中查找
    //   const { data: manufacturers } = await httpClient(`${apiUrl}/Admin/CMSProductCompany/GetList`, {
    //     method: 'POST',
    //     contentType: 'application/x-www-form-urlencoded',
    //     body: qs.stringify({ filter: JSON.stringify({ C_NameEN: manufacturerName }) })
    //   }).then(({ json }) => json);

    //   if (manufacturers && manufacturers.length > 0) {
    //     setValue('ProductCompany_id', manufacturers[0].id);
    //   } else {
    //     // 如果找不到，可以创建一个新的或者提示用户手动选择
    //     console.warn(`未找到厂家: ${manufacturerName}`);
    //     notify(`未找到厂家"${manufacturerName}"，请手动选择`, { type: 'warning' });
    //   }
    // } catch (error) {
    //   console.error('查找厂家失败:', error);
    // }
  };

  // 根据国家名称查找并设置产地ID
  const findAndSetCountry = async (countryName: string) => {
    // try {
    //   const { data: countries } = await httpClient(`${apiUrl}/Admin/CMSProductCountry/GetList`, {
    //     method: 'POST',
    //     contentType: 'application/x-www-form-urlencoded',
    //     body: qs.stringify({ filter: JSON.stringify({ C_Name: countryName }) })
    //   }).then(({ json }) => json);

    //   if (countries && countries.length > 0) {
    //     setValue('ProductCountry_id', countries[0].id);
    //   } else {
    //     console.warn(`未找到产地: ${countryName}`);
    //     notify(`未找到产地"${countryName}"，请手动选择`, { type: 'warning' });
    //   }
    // } catch (error) {
    //   console.error('查找产地失败:', error);
    // }
  };

  // 添加供货商信息
  const addSupplierInfoFromImport = (jsonData: any) => {
    const currentSuppliers = getValues('__item_products') || [];

    // 计算人民币价格（假设日元转人民币）
    let priceInRMB = jsonData.price;
    if (jsonData.price_unit === '円') {
      priceInRMB = jsonData.price * 0.05; // 日元转人民币
    }

    const newSupplier = {
      id: null, // 新添加的项，id为空
      IsMainId: currentSuppliers.length === 0, // 如果是第一个，设为主供货
      Supplier_id: null, // 需要用户手动选择供货商
      P_CostPrice: priceInRMB, // 成本价（人民币）
      P_CostPriceM: parseFloat((priceInRMB / 7.2).toFixed(2)), // 成本价（美元）
      P_Price: Math.round(priceInRMB * 2), // 细柔价（2倍）
      P_DLPrice: priceInRMB, // 服务商成本
      P_DLPriceM: parseFloat((priceInRMB / 7.2).toFixed(2)), // 服务商成本（美元）
      P_LimitNumMin: 1, // 起购数量
      P_LimitNum: 4, // 限购数量
      P_IsShelves: true, // 默认下架
      P_Reservation: false,
      P_IsHFGM: false,
      ISHuiZhen: false,
      P_Address: `导入价格: ${jsonData.price} ${jsonData.price_unit}` // 备注信息
    };

    setValue('__item_products', [...currentSuppliers, newSupplier]);
  };

  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    setParsing(true);

    try {
      // 解析JSON
      const parsedData = JSON.parse(jsonInput);

      // 支持多种JSON格式
      let importData = parsedData;

      // 如果是数组，取第一个
      if (Array.isArray(parsedData) && parsedData.length > 0) {
        importData = parsedData[0];
      }

      // 映射字段名（支持不同命名规范）
      const mappedData = {
        brand_name_en: importData.brand_name_en || importData.brandNameEn || importData.brand_name,
        brand_name_jp: importData.brand_name_jp || importData.brandNameJp || importData.brand_name_cn,
        generic_name_en: importData.generic_name_en || importData.genericNameEn || importData.generic_name,
        generic_name_cn: importData.generic_name_cn || importData.genericNameCn || importData.generic_name_ch,
        indication_cn: importData.indication_cn || importData.indication || importData.indications,
        dosage_form_en: importData.dosage_form_en || importData.dosageForm,
        dosage_form_cn: importData.dosage_form_cn,
        strength: importData.strength || importData.strength_clean || importData.content,
        package_unit: importData.package_unit || importData.packageUnit || importData.quantity,
        manufacturer: importData.manufacturer || importData.company || importData.factory,
        manufacturer_country: importData.manufacturer_country || importData.country || importData.origin,
        price: importData.price || importData.cost,
        price_unit: importData.price_unit || importData.currency || importData.unit
      };

      const success = await parseAndFillData(mappedData);

      if (success) {
        handleClose();
      }
    } catch (error) {
      console.error('JSON解析错误:', error);
      notify('JSON格式错误，请检查数据格式', { type: 'error' });
    } finally {
      setParsing(false);
    }
  };

  return (
    <div>
      <MButton onClick={handleClickOpen} variant="outlined" size="small">
        快捷录入基础数据
      </MButton>
      <Dialog open={open} onClose={handleClose} maxWidth="md" fullWidth>
        <DialogTitle>快速导入产品数据</DialogTitle>
        <DialogContent>
          <DialogContentText sx={{ mb: 2 }}>
            粘贴JSON格式的产品数据，系统将自动解析并填充到表单中。
            <br />
            <strong>支持的字段：</strong> brand_name_en, brand_name_jp, generic_name_en, generic_name_cn,
            indication_cn, dosage_form_en, strength, package_unit, manufacturer, manufacturer_country, price, price_unit
          </DialogContentText>
          <form onSubmit={handleSubmit} id="subscription-form">
            <MTextField
              multiline
              rows={10}
              autoFocus
              required
              margin="dense"
              label="JSON数据"
              type="text"
              fullWidth
              variant="outlined"
              value={jsonInput}
              onChange={(e) => setJsonInput(e.target.value)}
              placeholder={`示例：
{
  "brand_name_en": "ESANBUTOL",
  "brand_name_jp": "エサンブトール",
  "generic_name_en": "ethambutol",
  "generic_name_cn": "乙胺丁醇",
  "indication_cn": "非典型分枝杆菌感染、结核病。",
  "dosage_form_en": "tab",
  "dosage_form_cn": "片剂",
  "strength": "125mg",
  "package_unit": "100",
  "manufacturer": "Sandoz",
  "manufacturer_country": "日本",
  "price": 2900,
  "price_unit": "円"
}`}
            />
          </form>
        </DialogContent>
        <DialogActions>
          <MButton onClick={handleClose} disabled={parsing}>
            取消
          </MButton>
          <MButton
            type="submit"
            form="subscription-form"
            variant="contained"
            disabled={parsing}
          >
            {parsing ? '解析中...' : '确认导入'}
          </MButton>
        </DialogActions>
      </Dialog>
    </div>
  );
};

const MultipleSupplierItem = ({ key, getSource }: any) => {
  function sleep(time: number) {
    return new Promise(function (resolve) {
      setTimeout(resolve, time);
    });
  }
  const isSmall = useMediaQuery((theme: any) => theme.breakpoints.down('sm'));
  const inputRef = React.useRef<HTMLInputElement>(null);
  const { index } = useSimpleFormIteratorItem();
  const notify = useNotify();
  const redirect = useRedirect();
  const isXSmall = useMediaQuery((theme: any) => theme.breakpoints.down('xs'));
  const resource = useResourceContext();
  const { setValue, getValues } = useFormContext();
  const { register, handleSubmit, watch, setValue: setValue2, setFocus, formState: { errors } } = useForm();

  const mainChange = (e: any, idSource: any) => {
    const checked = e.target.checked;
    const id = getValues(idSource);
    console.log('checked', checked, id);
    if (checked) {
      sleep(1000);
      var __item_products = [...getValues('__item_products')];
      console.log('__item_products', __item_products);
      __item_products.filter((t => { if (t.id != id) t.IsMainId = false }));
      setValue('__item_products', __item_products)
    }
    else {
      alert('建议选择一个主供货信息')
    }
  }
  const removeItem = (idSource: any) => {
    if (window.confirm('确认要删除新项吗？')) {
      if (!getValues(idSource)) {
        var __item_products = [...getValues('__item_products')];
        console.log('__item_products', __item_products);
        __item_products.splice(index, 1);
        setValue('__item_products', __item_products)
      }
    }
  }

  const us_rmb = 7.2;
  const jpy_rmb = 0.05;
  const oy_us = 1.18;
  const autoJS = (sn: string) => {
    if (window.confirm('确认要使用自动计算价格吗？计算后需要自行在检查')) {
      var item_products = [...getValues('__item_products')];
      if (sn == "iRX") {
        var japanPrice = window.prompt(`请输入日元成本价【日元->${jpy_rmb}->人民币->${us_rmb}->美元】,零售价为2倍`, "");
        if (japanPrice != null && japanPrice != "") {
          var _japanPrice = parseFloat(japanPrice.replaceAll(",", ""));
          if (!isNaN(_japanPrice)) {
            const P_CostPrice = _japanPrice * jpy_rmb; //item_products[index]['P_CostPrice'];
            item_products[index]['P_CostPrice'] = parseFloat(P_CostPrice.toFixed(2));
            item_products[index]['P_CostPriceM'] = parseFloat((P_CostPrice / us_rmb).toFixed(2));
            const P_DLPrice = _japanPrice * jpy_rmb; //item_products[index]['P_DLPrice'];
            item_products[index]['P_DLPrice'] = parseFloat(P_DLPrice.toFixed(2));
            item_products[index]['P_DLPriceM'] = parseFloat((P_DLPrice / us_rmb).toFixed(2));
            item_products[index]['P_Price'] = parseInt((P_DLPrice * 2).toFixed(0));
            setValue('__item_products', item_products);
          }
        }
      }
      else if (sn == "cb_rmb") {
        var usPrice = window.prompt(`请输入美元成本价【美元->${us_rmb}->人民币】`, "");
        if (usPrice != null && usPrice != "") {
          var _usPrice = parseFloat(usPrice.replaceAll(",", ""));
          if (!isNaN(_usPrice)) {
            const P_CostPrice = _usPrice * us_rmb; //item_products[index]['P_CostPrice'];
            item_products[index]['P_CostPrice'] = parseFloat(P_CostPrice.toFixed(2));
            item_products[index]['P_CostPriceM'] = parseFloat((_usPrice).toFixed(2));
            item_products[index]['P_DLPrice'] = parseFloat(P_CostPrice.toFixed(2));
            item_products[index]['P_DLPriceM'] = parseFloat((_usPrice).toFixed(2));
            // item_products[index]['P_Price'] = parseInt((P_DLPrice * 2).toFixed(0));
            setValue('__item_products', item_products);
          }
        }
      }
      else if (sn == "cb_rmb_xirou") {
        var usPrice = window.prompt(`请输入美元成本价【美元->${us_rmb}->人民币】,零售价为2倍`, "");
        if (usPrice != null && usPrice != "") {
          var _usPrice = parseFloat(usPrice.replaceAll(",", ""));
          if (!isNaN(_usPrice)) {
            const P_CostPrice = _usPrice * us_rmb; //item_products[index]['P_CostPrice'];
            item_products[index]['P_CostPrice'] = parseFloat(P_CostPrice.toFixed(2));
            item_products[index]['P_CostPriceM'] = parseFloat((_usPrice).toFixed(2));
            item_products[index]['P_DLPrice'] = parseFloat(P_CostPrice.toFixed(2));
            item_products[index]['P_DLPriceM'] = parseFloat((_usPrice).toFixed(2));
            item_products[index]['P_Price'] = parseInt((P_CostPrice * 2).toFixed(0));
            setValue('__item_products', item_products);
          }
        }
      }
      else if (sn == "cb_rmb_xirou2") {
        var oyPrice = window.prompt(`请输入欧元成本价【欧元->${oy_us}->美元->${us_rmb}->人民币】,零售价为2倍`, "");
        if (oyPrice != null && oyPrice != "") {
          var _oyPrice = parseFloat(oyPrice.replaceAll(",", ""));
          var _usPrice = _oyPrice * oy_us;
          if (!isNaN(_usPrice)) {
            const P_CostPrice = _usPrice * us_rmb; //item_products[index]['P_CostPrice'];
            item_products[index]['P_CostPrice'] = parseFloat(P_CostPrice.toFixed(2));
            item_products[index]['P_CostPriceM'] = parseFloat((_usPrice).toFixed(2));
            item_products[index]['P_DLPrice'] = parseFloat(P_CostPrice.toFixed(2));
            item_products[index]['P_DLPriceM'] = parseFloat((_usPrice).toFixed(2));
            item_products[index]['P_Price'] = parseInt((P_CostPrice * 2).toFixed(0));
            setValue('__item_products', item_products);
          }
        }
      }
      else if (sn == "rmb_xirou") {
        if (window.confirm(`细柔价为2倍`)) {
          const P_CostPrice = item_products[index]['P_DLPrice'];
          item_products[index]['P_Price'] = parseInt((P_CostPrice * 2).toFixed(0));
          setValue('__item_products', item_products);
        }
      }
    }
  }

  return (
    <Stack direction={'row'} sx={{ gap: 1, width: '100%' }}>
      <Stack direction={'column'} alignItems={'flex-start'}>
        <BooleanInput label={'主'} onChange={(e) => mainChange(e, getSource('id'))} source={getSource('IsMainId')} helperText={false} validate={[]} defaultValue={false} />
        <Typography variant="subtitle1">{getValues(getSource('id'))}</Typography>
        {!getValues(getSource('id')) && <IconButton onClick={() => removeItem(getSource('id'))} aria-label="delete"><DeleteIcon /></IconButton>}
      </Stack>
      <Stack sx={{ flex: 1 }}>
        <Stack direction={'row'} sx={{ gap: 1, width: '100%' }}>
          <Stack>
            <Stack direction={'row'} sx={{ gap: 1 }}>
              <ReferenceInput source={getSource('Supplier_id')} reference="Admin/CMSSupplier" >
                <AutocompleteInput label='供货商' sx={{ width: 200 }} optionText={({ S_Name, S_CountryId }: any) => `${S_CountryId}-${S_Name}`} validate={[required()]} helperText={false} />
              </ReferenceInput>
              <NumberInput sx={{ width: 150 }} label={'供货商成本(¥)'} source={getSource('P_CostPrice')} helperText={false} validate={[]} />
              <NumberInput sx={{ width: 150 }} label={'供货商成本($)'} source={getSource('P_CostPriceM')} helperText={false} validate={[]} />
              <NumberInput sx={{ width: 100 }} label={'起购'} source={getSource('P_LimitNumMin')} helperText={false} validate={[required()]} defaultValue={1} step={1} />
            </Stack>
            <Stack direction={'row'} sx={{ gap: 1 }}>
              <NumberInput sx={{ width: 200 }} label={'细柔价(¥)'} source={getSource('P_Price')} helperText={false} validate={[]} />
              <NumberInput sx={{ width: 150 }} label={'服务商成本(¥)'} source={getSource('P_DLPrice')} helperText={false} validate={[]} />
              <NumberInput sx={{ width: 150 }} label={'服务商成本($)'} source={getSource('P_DLPriceM')} helperText={false} validate={[]} />
              <NumberInput sx={{ width: 100 }} label={'限购'} source={getSource('P_LimitNum')} helperText={false} validate={[]} step={1} />
            </Stack>
          </Stack>
          <Stack sx={{ flex: 1 }}>
            <TextInput multiline rows={3.8} label={'备注'} source={getSource('P_Address')} helperText={false} validate={[]} />
          </Stack>
        </Stack>
        <Stack direction={'row'} sx={{ gap: 1 }}>
          <MButton onClick={() => autoJS('rmb_xirou')}>细柔价为2倍</MButton>
          <MButton onClick={() => autoJS('cb_rmb')}>自动根据美元计算成本(人民币)</MButton>
          <MButton onClick={() => autoJS('cb_rmb_xirou')}>自动根据美元计算成本(人民币)、细柔价</MButton>
          <MButton onClick={() => autoJS('cb_rmb_xirou2')}>自动根据欧元计算成本(人民币)、细柔价</MButton>
          <MButton onClick={() => autoJS('iRX')}>自动计算成本(美元)、细柔价[iRX]</MButton>
        </Stack>
        <Stack direction={'row'} sx={{ gap: 1 }}>
          <BooleanInput label={'上架'} source={getSource('P_IsShelves')} helperText={false} validate={[]} defaultValue={false} />
          <BooleanInput label={'预定'} source={getSource('P_Reservation')} helperText={false} validate={[]} defaultValue={false} />
          <BooleanInput label={'恢购'} source={getSource('P_IsHFGM')} helperText={false} validate={[]} defaultValue={false} />
          <BooleanInput label={'会诊'} source={getSource('ISHuiZhen')} helperText={false} validate={[]} defaultValue={false} />
        </Stack>
      </Stack>
    </Stack>
  )

}

// const ShowSortView = () => {
//   const { data, isLoading, isError, error, isSuccess, refetch } = useQuery(['getSorts'], () =>
//     httpClient(`${apiUrl}/Admin/CMSProduct/GetSorts`, {
//       method: 'POST',
//       contentType: 'application/x-www-form-urlencoded',
//       body: qs.stringify({})
//     }).then(({ json }) => {
//       if (json.Code == 1) return json.Result || 'null';
//     }), { enabled: false }
//   )
//   return <>
//     {__sortArr.map(({ id, PC_Name, subList }: any) =>
//       <Stack>
//         <Stack sx={{ color: '#AAA' }}>{PC_Name}</Stack>
//         <Stack direction={'row'} sx={{ pl: 1 }} spacing={1}>
//           {subList.map(({ id, PC_Name }: any) =>
//             <Chip label={PC_Name} size='small' />
//           )}
//         </Stack>
//       </Stack>
//     )}
//   </>
// }

export const ChooseSortView = ({ C_Cate2 }: any) => {
  const { setValue, getValues } = useFormContext();
  // const Cate1 = C_Cate1 || '';
  const Cate2 = C_Cate2 || '';
  // const __sortArr = C__sortArr || [];
  const [_Cate2, Set_Cate2] = React.useState<any[]>(`,${Cate2},`.match(/[^,]+/g) || []);
  // const [___sortArr, Set___sortArr] = React.useState<any[]>(__sortArr);

  const [open, setOpen] = React.useState(false);
  const handleClickOpen = () => {
    setOpen(true);
    refetch();
  };
  const handleClose = () => {
    Set_Cate2(`,${Cate2},`.match(/[^,]+/g) || []);
    setOpen(false);
  };
  const handleConfirm = () => {
    setValue('Cate2', _Cate2.join(','));
    // setValue('__sortArr', ___sortArr);
    setOpen(false);
  }
  const itemClickHandle = (item: any, item2: any) => {
    const id2 = `${item2.id}`;
    // const ____sortArr = [...___sortArr];
    const __Cate2 = [..._Cate2];
    const _findIndex = __Cate2.indexOf(id2);
    if (_findIndex >= 0) {
      __Cate2.splice(_findIndex, 1);
      // const subList: any[] = ____sortArr.find(t => t.id == item.id).subList;
      // try { subList.splice(subList.findIndex(t => t.id == item2.id), 1) } catch { }
      // if (subList.length < 1) try { ____sortArr.splice(____sortArr.findIndex(t => t.id == item.id), 1) } catch { }
    }
    else {
      __Cate2.push(id2);

      // const sortItem1 = ____sortArr.find(t => t.id == item.id);
      // if (sortItem1 == null) {
      //   ____sortArr.push({ id: item.id, PC_Name: item.PC_Name, subList: [{ id: item2.id, PC_Name: item2.PC_Name }] })
      // }
      // else {
      //   sortItem1.subList.push({ id: item2.id, PC_Name: item2.PC_Name });
      // }
    }
    Set_Cate2(__Cate2);
    // Set___sortArr(____sortArr);
  }

  const { data, isLoading, isError, error, isSuccess, refetch } = useQuery(['getSorts'], () =>
    httpClient(`${apiUrl}/Admin/CMSProduct/GetSorts`, {
      method: 'POST',
      contentType: 'application/x-www-form-urlencoded',
      body: qs.stringify({})
    }).then(({ json }) => {
      if (json.Code == 1) return json.Result || 'null';
    }), { enabled: false }
  )

  return (
    <Stack alignItems={'flex-start'}>
      <MButton sx={{ mb: 2 }} variant='outlined' onClick={handleClickOpen}>
        选择分类
      </MButton>
      <SortView id={null} Cate2={_Cate2.join(',')} />
      <Dialog maxWidth='lg' open={open}>
        <DialogTitle id="alert-dialog-title">
          选择分类
        </DialogTitle>
        <DialogContent>
          {isLoading && <div>loading</div>}
          {isSuccess && <Stack alignItems={'flex-start'} spacing={2}>
            {data.map((item: any) => {
              const { id, PC_Name, subList }: any = item;
              return <Stack alignItems={'flex-start'} sx={{ gap: 1 }}>
                <Stack>{PC_Name}</Stack>
                <Stack direction={'row'} sx={{ pl: 2, gap: 1 }} flexWrap={'wrap'}>
                  {subList.map((item2: any) => {
                    const { id: id2, PC_Name: PC_Name2 }: any = item2;
                    const choose = _Cate2.indexOf(`${id2}`) >= 0;
                    return <Chip onClick={() => itemClickHandle(item, item2)} label={PC_Name2} variant={choose ? 'filled' : 'outlined'} color={choose ? 'primary' : 'default'} />
                  }
                  )}
                </Stack>
              </Stack>
            })}
          </Stack>
          }
        </DialogContent>
        <DialogActions>
          <MButton onClick={handleClose}>关闭</MButton>
          <MButton onClick={handleConfirm}>确定</MButton>
        </DialogActions>
      </Dialog>
    </Stack>
  )
}

export const ChooseSortViewByList = ({ id, C_Cate2, C__sortArr }: any) => {
  const refresh = useRefresh();
  // const Cate1 = C_Cate1 || '';
  const Cate2 = C_Cate2 || '';
  const __sortArr = C__sortArr || [];

  // const [_Cate2, Set_Cate2] = React.useState<any[]>(`,${Cate2},`.match(/[^,]+/g) || []);
  const [_Cate2, Set_Cate2] = React.useState<any[]>([]);

  const [open, setOpen] = React.useState(false);
  const handleClickOpen = () => {
    if (id != null) {
      setOpen(true);
      Set_Cate2(`,${Cate2},`.match(/[^,]+/g) || []);
      refetch();
    }
  };
  const handleClose = () => {
    setOpen(false);
  };
  const handleConfirm = () => {
    //提交信息
    console.log('_Cate2', id, _Cate2);
    _setSorts({ id, Cate2: _Cate2 });
    // handleClose();
  }
  const { mutate: _setSorts, isLoading: _setSorts_isLoading } = useMutation((data: any) =>
    httpClient(`${apiUrl}/Admin/CMSProduct/SetSorts`, {
      method: 'POST', contentType: 'application/x-www-form-urlencoded',
      body: qs.stringify(data)
    }).then(({ json }) => {
      if (json.Code == 1) {
        handleClose();
      } else {
        alert(json.Message); throw new HttpError(`${json.Message}`, 500);
      }
    }), {
    onSuccess: () => { refresh() },
    onError: (err) => { alert(`${err}`) }
  })
  const itemClickHandle = (item: any, item2: any) => {
    const id2 = `${item2.id}`;
    const __Cate2 = [..._Cate2];
    const _findIndex = __Cate2.indexOf(id2);
    if (_findIndex >= 0) {
      __Cate2.splice(_findIndex, 1);
    }
    else {
      __Cate2.push(id2);
    }
    Set_Cate2(__Cate2);
  }

  const { data, isLoading, isError, error, isSuccess, refetch } = useQuery(['getSorts'], () =>
    httpClient(`${apiUrl}/Admin/CMSProduct/GetSorts`, {
      method: 'POST',
      contentType: 'application/x-www-form-urlencoded',
      body: qs.stringify({})
    }).then(({ json }) => {
      if (json.Code == 1) return json.Result || 'null';
    }), { enabled: false }
  )

  return (
    <Stack>
      <Stack onClick={() => handleClickOpen()}>
        {
          __sortArr.length == 0 ? <Stack>没有分类</Stack>
            :
            <>{
              __sortArr.map(({ id, PC_Name, subList }: any) =>
                <Stack direction={'row'} alignItems={'center'}>
                  <Stack sx={{ color: '#AAA' }}>{PC_Name}</Stack>
                  <Stack direction={'row'} sx={{ pl: 1 }} spacing={1}>
                    {subList.map(({ id, PC_Name }: any) =>
                      <Chip label={PC_Name} size='small' color={PC_Name == '普药推荐' ? 'primary' : PC_Name == '新药推荐' ? 'secondary' : 'default'} />
                    )}
                  </Stack>
                </Stack>
              )}
            </>
        }
      </Stack>
      <Dialog maxWidth='lg' open={open}>
        <DialogTitle id="alert-dialog-title">
          选择分类
        </DialogTitle>
        <DialogContent>
          {isLoading && <div>loading</div>}
          {isSuccess && <Stack alignItems={'flex-start'} spacing={2}>
            {data.map((item: any) => {
              const { id, PC_Name, subList }: any = item;
              return <Stack alignItems={'flex-start'} sx={{ gap: 1 }}>
                <Stack>{PC_Name}</Stack>
                <Stack direction={'row'} sx={{ pl: 2, gap: 1 }} flexWrap={'wrap'}>
                  {subList.map((item2: any) => {
                    const { id: id2, PC_Name: PC_Name2 }: any = item2;
                    const choose = _Cate2.indexOf(`${id2}`) >= 0;
                    return <Chip onClick={() => itemClickHandle(item, item2)} label={PC_Name2} variant={choose ? 'filled' : 'outlined'} color={choose ? 'primary' : 'default'} />
                  }
                  )}
                </Stack>
              </Stack>
            })}
          </Stack>
          }
        </DialogContent>
        <DialogActions>
          {!_setSorts_isLoading && <MButton onClick={handleClose}>关闭</MButton>}
          <MButton disabled={_setSorts_isLoading} onClick={handleConfirm}>{_setSorts_isLoading ? '更新中...' : '确定'}</MButton>
        </DialogActions>
      </Dialog>
    </Stack>
  )
}

const ImagePaster = () => {
  const { setValue, getValues } = useFormContext();
  React.useEffect(() => {
    // console.log('P_Images', getValues('P_Images'));

    // 监听粘贴事件
    const handlePaste = (event: any) => {
      // 检查剪贴板是否有文件
      const items = (event.clipboardData || event.originalEvent.clipboardData).items;
      for (let i = 0; i < items.length; i++) {
        const item = items[i];
        // 如果是文件且是图片类型
        if (item.kind === 'file' && item.type.startsWith('image/')) {
          console.log('item', item);
          const file = item.getAsFile();
          console.log('file', file);
          console.log('file.raw', file.raw);
          if (file) {
            // 处理图片文件
            handleImageUpload(file);
          }
        }
      }
    };
    document.addEventListener('paste', handlePaste);
    return () => {
      // 清除事件监听器，避免内存泄漏
      document.removeEventListener('paste', handlePaste);
    };
  }, []);

  const handleImageUpload = (file: any) => {
    console.log('Detected a pasted image file:', file);
    // 在这里调用你的图片上传逻辑
    // 例如：将文件上传到服务器
    let old_P_Images = getValues('P_Images');

    if (old_P_Images == null) old_P_Images = [];
    old_P_Images.push({ rawFile: file, src: URL.createObjectURL(file), title: file.name });
    setValue('P_Images', old_P_Images);

    console.log(old_P_Images);
  };

  return (
    <div style={{ fontSize: 12 }}></div>
  );
};